import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import type { ISbComponentType, ISbStoryData } from "storyblok-js-client";

const resolveGlobalComponent = (globalComponent: ISbStoryData<ISbComponentType<string>>) => ({
  component: "global_reference",
  reference: globalComponent,
});

export const renderGlobalComponent = (
  globalComponent: ISbStoryData<ISbComponentType<string>>,
  extraParams?: Record<string, unknown>
) => (globalComponent ? renderDynamicComponent([resolveGlobalComponent(globalComponent)], extraParams) : null);
